import React from 'react';
import TickWhite from '../../images/health-content/calorie-card-tick.png';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export default function CalorieGraph({ calorieCard }) {
  console.log('calorieCard', calorieCard);
  const labels = calorieCard?.progressWeek?.map((el) => el.day);
  const stepsData = calorieCard?.progressWeek?.map((el) => el.steps);
  const goalData = calorieCard?.progressWeek?.map((el) => el.workout);
  const stepsGoal = calorieCard?.progressWeek?.map((el) => el.stepsGoal);
  const workoutGoal = calorieCard?.progressWeek?.map((el) => el.workoutGoal);

  const data = {
    labels,
    datasets: [
      {
        label: 'Steps',
        data: stepsData,
        backgroundColor: '#5A68E7',
        borderRadius: 4,
        barPercentage: 0.6,
        categoryPercentage: 0.8,
        stack: 'stack1',
      },
      {
        label: 'Workout',
        data: goalData,
        backgroundColor: '#FF865C',
        borderRadius: 4,
        barPercentage: 0.6,
        categoryPercentage: 0.8,
        stack: 'stack1',
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      goalPlugin: { stepsGoal, workoutGoal },
    },
    scales: {
      x: {
        stacked: true,
        grid: { display: false },
      },
      y: {
        stacked: true,
        display: false,
      },
    },
  };

  // put outside the component
  const goalPlugin = {
    id: 'goalPlugin',
    afterDatasetsDraw(chart, args, pluginOpts) {
      const { ctx, data, scales } = chart;

      // read goals from options or fallback
      const stepsGoal = chart.options.plugins?.goalPlugin?.stepsGoal ?? 4000;
      const workoutGoal =
        chart.options.plugins?.goalPlugin?.workoutGoal ?? 6000;

      const stepsIdx = 0; // dataset index for "Steps" (blue)
      const workoutIdx = 1; // dataset index for "Workout" (orange)

      const stepsMeta = chart.getDatasetMeta(stepsIdx);
      const workoutMeta = chart.getDatasetMeta(workoutIdx);

      const drawTick = (x, y) => {
        // white tick
        const img = new Image();
        img.src = TickWhite;
        img.onload = () => {
          const size = 10;
          ctx.drawImage(img, x - size / 2, y - size - 1, size, size);
        };
      };

      // iterate each day
      for (let i = 0; i < data.labels.length; i++) {
        const stepsVal = Number(data.datasets[stepsIdx].data[i] ?? 0);
        const workoutVal = Number(data.datasets[workoutIdx].data[i] ?? 0);

        // ✅ only when BOTH goals are met
        if (stepsVal >= stepsGoal && workoutVal >= workoutGoal) {
          // get bar elements for the day
          const sEl = stepsMeta.data[i]; // blue segment element
          const wEl = workoutMeta.data[i]; // orange segment element

          // place tick at the VERTICAL CENTER of each segment
          const sYmid = (sEl.y + sEl.base) / 2;
          const wYmid = (wEl.y + wEl.base) / 2;

          // scale tick size to segment height, capped for aesthetics
          const sSize = Math.min(Math.abs(sEl.base - sEl.y) * 0.6, 20);
          const wSize = Math.min(Math.abs(wEl.base - wEl.y) * 0.6, 20);

          // draw one tick inside blue + one inside orange
          drawTick(sEl.x, sYmid, sSize);
          drawTick(wEl.x, wYmid, wSize);
        }
      }
    },
  };

  return (
    <div
      className="pl-28px overflow-hidden"
      style={{ width: '440px', height: '120px' }}
    >
      <Bar data={data} options={options} plugins={[goalPlugin]} />
    </div>
  );
}
